import BreadCrumb from "common/breadcrumb";
import React from "react";
import BasicNavbar from "./basic-navbar";
import HamburgerMenu from "./hamburger-menu";
import NavbarButton from "./navbar-button";
import NavbarSearch from "./navbar-search";
import DarkNavbar from "./dark-navbar";

const NavBars = () => {
    return (
        <React.Fragment>
            <div className="container-fluid group-data-[content=boxed]:max-w-boxed mx-auto">
                <BreadCrumb title="Navbar" pageTitle="Navigation" />
                <BasicNavbar />
                <HamburgerMenu />
                <NavbarButton />
                <NavbarSearch />
                <DarkNavbar />
            </div>
        </React.Fragment>
    );
}

export default NavBars;